<template>
  <div>
    <v-container >
      <CRUDCriteria
        :showSearch="false"
        :showReset="true"
      >
        <template v-slot:criteriaRows>
          <v-row>
            <v-col cols="2">
              <v-select
                class="tax-levy-by-tax-year-select"
                v-model.number="criteriaState.taxYear"
                :items="sortedTaxYearRange"
                label="By Tax Year"
                @input="searchByCriteria"
              ></v-select>
            </v-col><v-col cols="3">
            <v-autocomplete
              class="tax-levy-by-district-select"
              v-model="criteriaState.taxDistrict"
              label="By District"
              item-text="districtDesc"
              item-value="_id"
              :items="districtList"
              @change="searchByCriteria"
            >
            </v-autocomplete>
            <v-col cols="3" class="ml-6">
        </v-col>
          </v-col>
          <v-col cols="3" class="ml-6">
          <v-btn color="primary" rounded dense v-if="criteriaState.taxYear"
            :disabled="disableCreateNewItem"
            class="tmc-additional-actions mt-4" @click="copyLeviesToNewTaxYear">
            Copy Levies to New Tax Year
          </v-btn>
          </v-col>
          <v-col cols="3" class="ml-6">
    <v-btn
      color="primary"
      rounded
      dense
      class="tmc-additional-actions mt-4"
      @click="openReport"
    >
      Print Levies
    </v-btn>
    <v-btn
      color="primary"
      rounded
      dense
      class="tmc-additional-actions mt-4 ml-4"
      @click="openDetailedReport"
    >
      Levy Report with Detail
    </v-btn>
  </v-col>
          <v-col v-if="isTmAdmin" cols="3" class="ml-6">
            <v-btn
              color="primary"
              rounded
              dense
              class="tmc-additional-actions mt-4"
              @click="validateRecords"
            >
              Validate Records
            </v-btn>
          </v-col>
          </v-row>
        </template>
      </CRUDCriteria>
      <CRUDList
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :canDelete="canDeleteFromSharedList"
        :headers="headers"
        :showTotal="true"
        :baseCrudKey="baseCrudKey"
        :createNewItem="newItemDialog"
        :customItemTotal="showMillsPercentTotal"
        toolbarTitle="Tax Unit"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        @emitDeleteRowItem="deleteItem"
        :defaultSortBy="sortBy"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <taxLevyEditedItem
            :baseCrudKey="baseCrudKey"
            :isSuperAdmin="isSuperAdmin"
          />
        </template>
        <template v-slot:[`additionalActions`]="{}">
        <v-btn  text color="blue darken-1"
        :disabled="!isSuperAdmin"
        @click="applyChangesToAllYears">APPLY TO ALL YEARS</v-btn>
      </template>
      </CRUDList>
      <CommonPopUp v-model="showOrHideDialog" v-if="showOrHideDialog"
      :enableFlashTypeMsg="false" >
      <template v-slot:customsLabelOrInfo>
        <p class="mt-3">This will make a copy all {{ criteriaState.taxYear }}
          tax levies and create the new tax year {{ criteriaState.taxYear + 1 }}.
        You will need to modify your {{ criteriaState.taxYear + 1 }} levies.</p>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmPopUp('Yes')">Yes</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmPopUp('No')">No</v-btn>
      </template>
    </CommonPopUp>
    <v-dialog v-model="isRequiredToShowErrorDialog" max-width="600px">
        <v-card>
          <v-card-text class="pt-4">
            <v-alert type="error" outlined>
              <strong>Validation Errors</strong>
            </v-alert>
            <div v-if="validationErrorData.length">
              <h4>
                Record Details ({{ currentErrorIndex + 1 }} of {{ validationErrorData.length }}):
              </h4>
              <v-simple-table dense>
                <tbody>
                    <tr>
                      {{ validationErrorData[currentErrorIndex].message }}
                    </tr>
                  <tr>
                    <td class="error--text"
                      v-html="Array.isArray(validationErrorData[currentErrorIndex].values)
                        ? validationErrorData[currentErrorIndex].values.join('<br>')
                        : (typeof validationErrorData[currentErrorIndex].values === 'string'
                          ? validationErrorData[currentErrorIndex].values
                          .replace(/\n/g, '<br>')
                          .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
                          : validationErrorData[currentErrorIndex].values)"></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="currentErrorIndex < validationErrorData.length - 1"
              color="primary"
              text
              @click="showNextError"
            >
              <v-icon left>mdi-arrow-right</v-icon>
              Continue ({{ currentErrorIndex + 1 }}/{{ validationErrorData.length }})
            </v-btn>
            <v-btn
              v-else
              color="primary"
              text
              disabled
            >
              <v-icon left>mdi-check</v-icon>
              Continue
            </v-btn>
            <v-btn color="error" text @click="hideErrorWindow">
              <v-icon left>mdi-close</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapState,
  mapMutations,
} from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import CRUDCriteria from '../../common/base/crud/CRUDCriteria.vue';
import taxLevyEditedItem from './taxLevyEditedItem.vue';
import {
  amountToNumber,
  defaultGridLoading, manageGridLoading,
  extractId,
} from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

import {
  getFYList,
  toFiscalYear,
  toTaxYear,
} from '../../../util/shared/tmc-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import { getRawJwt } from '../../../util/jwt';
import { queryStringForTaxLeavies } from '../../Gl/Transaction/report-util';
import CommonPopUp from '../../tax/common-utils/CommonPopUp.vue';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles, TM_ADMIN_JWT_ROLES } from '../../../router/roleGroups';

const getHeaders = () => {
  const headers = [
    { text: 'To Fund', value: 'taxFund.fundNumber' },
    { text: 'Description', value: 'taxFund.description' || '' },
    { text: 'Tax Unit', value: 'taxUnit.toUnitDescForAppro' },
    { text: 'Shared Fund', value: 'fund.fund' },
    { text: 'Tax District', value: 'taxDistrict.districtCode' },
    { text: 'Mills', value: 'mills' },
    { text: 'Percent', value: 'levyPercent' },
  ];
  return headers;
};
const { backendRest } = clients.direct;

export default {
  name: 'taxLevyList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDCriteria,
    CRUDList,
    taxLevyEditedItem,
    CommonPopUp,
  },
  data: () => ({
    showOrHideDialog: false,
    baseCrudKey: 'sharedTaxLevy',
    taxDistrictCrudKey: 'sharedTaxDistrict',
    disableCreateNewItem: false,
    gridLoading: defaultGridLoading(),
    headers: [],
    sortBy: [
      {
        column: 'taxFund.fundNumber',
        direction: 'desc',
      },
    ],
    isRequiredToShowErrorDialog: false,
    validationErrorData: [],
    currentErrorIndex: 0,
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
    this.loadLists();
    // this.criteriaState.taxYear = toTaxYear(new Date(this.todaysDate));
    this.loadTaxRegYears().then((value) => {
      this.criteriaState.taxYear = value.max || 0;
    });
  },
  computed: {
    ...mapGetters('auth/token', ['authUserRoles']),
    // TmcSupport or restore-DB roles; unlike the comment dialogs' isTmAdmin (TmcSupport only).
    isTmAdmin() {
      return (this.authUserRoles || []).some((r) => TM_ADMIN_JWT_ROLES.includes(r));
    },
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      taxYearMaxMin: (state) => state.shared.taxLevy.regYears || {},
      taxYearRange: (state) => {
        const registerdYears = state.shared.taxLevy.regYears || {};
        const tyList = getFYList(registerdYears);
        return tyList.sort((a, b) => b - a);
      },
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    sortedTaxYearRange() {
      return [...(this.taxYearRange || [])].sort((a, b) => b - a);
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin) || isAuthorised(authRoles.UserAdmins);
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    // TODO: we don't necessarily want current fy
    currentFiscalYear() {
      return toFiscalYear(new Date(this.todaysDate));
    },
    currentTaxYear() {
      return toTaxYear(new Date(this.todaysDate));
    },
    districtList() {
      const districtDescObj = this.items(this.taxDistrictCrudKey) || [];
      const updatedDistDescObj = districtDescObj.map((d) => ({
        ...d,
        districtDesc: `${d.districtCode || ''}  ${d.districtName || ''}`,
      }));
      updatedDistDescObj.sort((a, b) => (a.districtCode || '').localeCompare(b.districtCode));
      return [{ _id: null, districtCode: '', districtDesc: '' }, ...updatedDistDescObj];
    },

    showMillsPercentTotal() {
      const totalMills = (this.items(this.baseCrudKey) || []).reduce((acc, obj) => acc
        + amountToNumber(obj.mills), 0).toFixed(2);
      const total = ((this.items(this.baseCrudKey) || []).reduce((acc, obj) => acc
        + amountToNumber(obj.levyPercent), 0));
      const totalPercent = Math.round(total).toFixed(3);
      return `Total Mills : ${totalMills} Total %: ${totalPercent}`;
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions('shared/taxLevy', [
      'loadTaxLevy',
      'upsertTaxLevy',
      'deleteTaxLevy',
      'upsertBulkTaxLevy',
      'loadTaxRegYears',
      'newYearForTaxLevy',
      'upsertTaxLevyDataForAllYears',
      'validateTaxLevy',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('shared/taxFund', [
      'loadTaxFund',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadTaxUnit',
      'loadMaxFiscalYear',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
    ]),
    ...mapActions(['reAuth', 'flashError', 'flashSuccess', 'flashInfo']),
    async handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      const maxFiscalYear = await this.loadMaxFiscalYear() || this.currentFiscalYear;

      if (maxFiscalYear) {
        criteria.fiscalYear = maxFiscalYear;
      }

      if (this.criteriaState.taxDistrict) {
        manageGridLoading(this, true, 'Searching...');
        this.loadTaxLevy({
          criteria,
          baseCrudKey,
        }).finally(() => {
          manageGridLoading(this, false);
        });
      }
    },
    async upsrtTransaction(item) {
      const updatedItem = { ...item };
      updatedItem.mills = amountToNumber(updatedItem.mills);
      const result = this.bulkUpsertLevyPercent(updatedItem);
      this.upsertAndloadTransactions(result);
    },
    async upsertAndloadTransactions(result) {
      const { baseCrudKey } = this;
      const resultItems = [...result];
      for (let i = 0; i < (result || []).length; i += 1) {
        if (result[i].taxUnit) {
          resultItems[i].taxUnit = extractId(result[i].taxUnit);
        }
        if (result[i].taxDistrict) {
          resultItems[i].taxDistrict = extractId(result[i].taxDistrict);
        }
        if (result[i].taxFund) {
          resultItems[i].taxFund = extractId(result[i].taxFund);
        }
        if (result[i].fund) {
          resultItems[i].fund = extractId(result[i].fund);
        }
      }
      await this.upsertBulkTaxLevy({ item: resultItems, baseCrudKey });
      this.handleLoadCRUDList();
    },
    async loadLists() {
      const maxFiscalYear = await this.loadMaxFiscalYear();
      this.loadTaxDistrict({
        criteria: {},
        baseCrudKey: 'sharedTaxDistrict',
      });
      this.loadTaxFund({
        criteria: {
          sortBy: [
            {
              column: 'fundNumber',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: 'sharedTaxFund',
      });
      this.loadFunds({
        criteria: {},
        baseCrudKey: 'sharedFund',
      });
      await this.loadTaxUnit({
        criteria: {
          fiscalYear: maxFiscalYear || this.currentFiscalYear,
        },
        baseCrudKey: 'sharedTaxUnit',
      });
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        taxYear: this.criteriaState.taxYear,
      };
      if (this.criteriaState.taxDistrict && this.criteriaState.taxDistrict.length > 0) {
        newItem.taxDistrict = this.criteriaState.taxDistrict;
      }
      return newItem;
    },
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
    },
    searchByCriteria() {
      const registerdYears = this.taxYearMaxMin || {};
      // disable create new item if tax year is not the max tax year (lastest tax year)
      if (this.criteriaState.taxYear !== registerdYears.max) this.disableCreateNewItem = true;
      else this.disableCreateNewItem = false;
      this.handleLoadCRUDList();
    },
    bulkUpsertLevyPercent(updatedItem) {
      const listFromState = (this.items(this.baseCrudKey));
      let updatedStateList = [];
      if (this.isNewItem) {
        updatedStateList = [...listFromState];
      } else {
        updatedStateList = listFromState.filter((obj) => obj._id !== updatedItem._id);
      }
      const updatedList = [...updatedStateList, updatedItem];

      const updatedLevyList = this.calculateLevyPercent(updatedList);
      return updatedLevyList;
    },
    calculateLevyPercent(levyList) {
      const taxFunds = (this.items('sharedTaxFund') || []);
      const grossAssessedTrue = taxFunds.filter((tf) => tf.grossAssessed === true);
      const levyListArray = [...levyList];
      const grossAssessedIds = new Set(grossAssessedTrue.map((gf) => gf._id));

      // const totalMills = (levyListArray || []).reduce((acc, obj) => acc
      //       + amountToNumber(obj.mills), 0);
      const totalMills = (levyListArray || []).reduce((acc, obj) => {
        const taxFundId = extractId(obj.taxFund);
        if (grossAssessedIds.has(taxFundId)) {
          return acc;
        }
        return acc + amountToNumber(obj.mills);
      }, 0);
      for (let i = 0; i < (levyListArray || []).length; i += 1) {
        const taxFundId = extractId(levyListArray[i].taxFund);

        if (grossAssessedIds.has(taxFundId)) {
          levyListArray[i].levyPercent = 0;
        } else {
          levyListArray[i].levyPercent = levyListArray[i].mills / totalMills;
        }
      }
      return levyListArray;
    },
    async openReport() {
      const criteria = { ...this.criteriaState };
      const token = this.getAuthToken;
      const queryString = queryStringForTaxLeavies({ criteria, token });
      const url = `${backendRest.defaults.baseURL}/shared/taxLevies-report${queryString}`;
      window.open(url, '_blank');
    },
    async openDetailedReport() {
      const criteria = { ...this.criteriaState };
      const token = this.getAuthToken;
      const queryString = queryStringForTaxLeavies({ criteria, token });
      const url = `${backendRest.defaults.baseURL}/shared/taxLevies-detailed-report${queryString}`;
      window.open(url, '_blank');
    },
    async deleteItem(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        await this.deleteTaxLevy({ item, baseCrudKey });
        const levyList = this.items(this.baseCrudKey);
        const result = this.calculateLevyPercent(levyList);
        this.upsertAndloadTransactions(result);
      }
    },
    copyLeviesToNewTaxYear() {
      this.showOrHideDialog = true;
    },
    openConfirmPopUp(value) {
      if (value === 'Yes') this.callTheNewYearForTaxLevy();
      this.showOrHideDialog = false;
    },
    async callTheNewYearForTaxLevy() {
      const item = {
        taxYear: this.criteriaState.taxYear,
      };
      const result = await this.newYearForTaxLevy({ item });
      if (result.statusCode === 200) {
        this.loadTaxRegYears().then(() => {
          this.criteriaState.taxYear = this.criteriaState.taxYear + 1 || 0;
        });
        this.handleLoadCRUDList();
      }
    },
    async applyChangesToAllYears() {
      if (window.confirm('Are you sure you want to apply the current year levies to all years?')) {
        try {
          manageGridLoading(this, true, 'Applying changes to all years...');
          const { baseCrudKey } = this;
          // Filter editedItem according to tax levy model
          const updatedItem = this.filterTaxLevyModelFields(this.editedItem);
          const result = await this.upsertTaxLevyDataForAllYears(
            { item: updatedItem, baseCrudKey },
          );
          if (result && result.ok) {
            this.flashSuccess('Tax Levy data upserted for all years successfully');
          } else {
            this.flashError('There was a problem in upserting the Tax Levy for all years');
          }
          this.handleLoadCRUDList();
        } catch (error) {
          if (error.response && error.response.status === 401) {
            await this.reAuth();
            this.upsertTaxLevyDataForAllYears();
          } else {
            this.flashError({ message: error.message || 'An error occurred while applying changes to all years', type: 'error' });
          }
        } finally {
          manageGridLoading(this, false);
        }
      }
    },
    filterTaxLevyModelFields(item) {
      // Only keep fields relevant to the tax levy model
      const taxUnitFlag = this.globalSettingItem.useNewTaxUnitSetup;
      let taxUnit = '';
      if (taxUnitFlag) {
        taxUnit = item.toUnitDescForAppro;
      } else {
        taxUnit = item.taxUnit;
      }
      const allowedFields = {
        _id: item._id,
        taxYear: item.taxYear,
        taxDistrict: item.taxDistrict._id || null,
        taxFund: item.taxFund._id || null,
        fund: item.fund._id || null,
        taxUnit: taxUnit || null,
        mills: item.mills || null,
        levyPercent: item.levyPercent || null,
        is4Mill: item.is4Mill || false,
      };
      return allowedFields;
    },
    async validateRecords() {
      if (this.criteriaState.taxYear) {
        if (window.confirm('Are you sure you want to validate these items?')) {
          const initialCriteria = {
            taxYear: this.criteriaState.taxYear,
          };
          try {
            const validationResult = await this.validateTaxLevy({ criteria: initialCriteria });
            if (validationResult && validationResult.isValid === 'false') {
              // Access each message and its values
              this.validationErrorData = validationResult.messages || [];
              this.currentErrorIndex = 0;
              this.isRequiredToShowErrorDialog = true;
            } else {
              this.flashSuccess('All records are valid!');
            }
          } catch (e) {
            alert(`Validation failed:  ${e.message || e}`);
          }
        }
      } else {
        this.flashInfo('Please select Tax Year!');
      }
    },
    showNextError() {
      if (this.currentErrorIndex < this.validationErrorData.length - 1) {
        this.currentErrorIndex += 1;
      }
    },
    hideErrorWindow() {
      this.currentErrorIndex = 0;
      this.validationErrorData = [];
      this.isRequiredToShowErrorDialog = false;
      this.handleLoadCRUDList();
    },
  },
};

</script>
